module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registerContent"
  }, [_c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "registerTitle"
  }, [_vm._v("用户注册")]), _vm._v(" "), _c('div', {
    staticClass: "registerUserName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "registerPassword"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": _vm.passwordType,
      "placeholder": "请输入数字、字母、特殊字符组合密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.passwordType === 'password') ? _c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png"
    },
    on: {
      "click": _vm.handlePassword
    }
  }) : _c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png"
    },
    on: {
      "click": _vm.handlePassword
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "registerConfirmPassword"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password_confirmation),
      expression: "form.password_confirmation",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入确认密码"
    },
    domProps: {
      "value": (_vm.form.password_confirmation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password_confirmation", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "registerCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.code),
      expression: "form.code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('img', {
    attrs: {
      "src": _vm.codeUrl
    }
  }), _c('div', {
    on: {
      "click": _vm.refreshCaptcha
    }
  }, [_vm._v("刷新")])]), _vm._v(" "), _c('div', {
    staticClass: "registerShortMsgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.shortMsgCode),
      expression: "form.shortMsgCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "shortMsgCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.form.shortMsgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "shortMsgCode", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.isSendMsg) ? _c('div', {
    staticClass: "sendbtn",
    on: {
      "click": _vm.toSendMsg
    }
  }, [_vm._v(" " + _vm._s(_vm.shortMsgCodeContent))]) : _c('div', {
    staticClass: "sendbtn1"
  }, [_vm._v(" " + _vm._s(_vm.shortMsgCodeContent) + "(" + _vm._s(_vm.countDown) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "registerBtn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "立即注册"
    },
    on: {
      "click": _vm.submitForm
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "registerRegister"
  }, [_vm._v("已有账号？"), _c('span', {
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("立即登陆")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed05bae6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Register.vue
// module id = 786
// module chunks = 2